export function addAgentSelector() {
    const preferredOs = detectPreferredOsTab();
    const cleanups = [
        addButtonSelector("agentTab", "agentPanel"),
        addButtonSelector("claudeOsTab", "claudeOsPanel", preferredOs),
        addButtonSelector("codexOsTab", "codexOsPanel", preferredOs),
        addButtonSelector("opencodeOsTab", "opencodeOsPanel", preferredOs),
    ];
    return () => {
        cleanups.forEach((cleanup) => cleanup());
    };
}
function addButtonSelector(tabDataKey, panelDataKey, preferredValue) {
    const tabs = Array.from(document.querySelectorAll(`[data-${camelToKebab(tabDataKey)}]`));
    const panels = Array.from(document.querySelectorAll(`[data-${camelToKebab(panelDataKey)}]`));
    const cleanups = [];
    const setActiveValue = (value) => {
        tabs.forEach((tab) => {
            const isActive = tab.dataset[tabDataKey] === value;
            tab.setAttribute("aria-pressed", isActive ? "true" : "false");
            tab.style.borderColor = isActive ? "#C8A050" : "#252520";
            tab.style.background = isActive
                ? "rgba(200, 160, 80, 0.12)"
                : "transparent";
            tab.style.color = isActive ? "#C8A050" : "#C0BAA8";
        });
        panels.forEach((panel) => {
            panel.style.display =
                panel.dataset[panelDataKey] === value ? "block" : "none";
        });
    };
    tabs.forEach((tab) => {
        const onClick = () => {
            const value = tab.dataset[tabDataKey];
            if (!value) {
                return;
            }
            setActiveValue(value);
        };
        tab.addEventListener("click", onClick);
        cleanups.push(() => {
            tab.removeEventListener("click", onClick);
        });
    });
    const preferredTab = preferredValue
        ? tabs.find((tab) => tab.dataset[tabDataKey] === preferredValue)
        : undefined;
    const defaultValue = preferredTab?.dataset[tabDataKey] ??
        tabs.find((tab) => tab.getAttribute("aria-pressed") === "true")?.dataset[tabDataKey] ??
        tabs[0]?.dataset[tabDataKey];
    if (defaultValue) {
        setActiveValue(defaultValue);
    }
    return () => {
        cleanups.forEach((cleanup) => cleanup());
    };
}
function camelToKebab(value) {
    return value.replace(/[A-Z]/g, (char) => `-${char.toLowerCase()}`);
}
function detectPreferredOsTab() {
    const userAgent = navigator.userAgent;
    const platform = navigator.platform;
    const maxTouchPoints = navigator.maxTouchPoints ?? 0;
    const isIosDevice = /iPhone|iPad|iPod/i.test(userAgent) ||
        (platform === "MacIntel" && maxTouchPoints > 1);
    const isAndroidDevice = /Android/i.test(userAgent);
    const isMobileDevice = isIosDevice || isAndroidDevice || /Mobile|Windows Phone/i.test(userAgent);
    if (isMobileDevice) {
        return isIosDevice ? "macos" : "linux";
    }
    if (/Win/i.test(platform) || /Windows/i.test(userAgent)) {
        return "windows";
    }
    if (/Mac/i.test(platform) || /Mac OS X/i.test(userAgent)) {
        return "macos";
    }
    return "linux";
}
